"use strict";
const SEC_PER_HOUR = 3600;
/**
 * 金币大作战参与人数模拟计算器
 */
class CoinMatchAttendCalculator {
    /**
     * 实例化一个参与人数计算器
     * @param {number} startTime  活动开始时间
     * @param {Array<number>} attendHoursCounts 每小时新增人数配置数组
     */
    static create(startTime, attendHoursCounts) {
        return new CoinMatchAttendCalculator(startTime, attendHoursCounts);
    }
    /**
     * 实例化一个参与人数计算器
     * @param {number} startTime 活动开始时间
     * @param {Array<number>} attendHoursCounts 每小时新增人数配置数组
     */
    constructor(startTime, attendHoursCounts) {
        // 简易线性插值
        this._pcore = (a, b, f) => {
            f = f < 0 ? 0 : f;
            f = f > 1 ? 1 : f;
            return a + (b - a) * f;
        };
        this._startTime = startTime;
        this._hoursSumCounts = [];
        let total = 0;
        for (let i = 0; i < attendHoursCounts.length; i++) {
            this._hoursSumCounts.push(total);
            total += attendHoursCounts[i];
        }
        this._hoursSumCounts.push(total);
    }
    /**
     * 获取当前模拟参与人数数量
     * @returns {number}
     */
    getCurValue() {
        let passedTime = this.curTime() - this._startTime;
        let hour = Math.floor(passedTime / SEC_PER_HOUR);
        if (hour >= 0 && hour < this._hoursSumCounts.length - 1) {
            let cur = this._hoursSumCounts[hour];
            let next = this._hoursSumCounts[hour + 1];
            let point = (passedTime - hour * SEC_PER_HOUR) / SEC_PER_HOUR;
            return Math.floor(this._pcore(cur, next, point));
        }
        else if (hour < 0) {
            //活动尚未开始
            return 0;
        }
        else {
            //活动已结束
            return this._hoursSumCounts[this._hoursSumCounts.length - 1];
        }
    }
    curTime() {
        if (Localhost) {
            return Localhost.timeInSec();
        }
        else {
            return Date.now() / 1000;
        }
    }
}
module.exports = CoinMatchAttendCalculator;
